import { SupportedLocale } from './locale'

/** Max venues a management admin may pin as favorites (see `favoriteVenues`). */
export const MANAGEMENT_USER_MAX_FAVORITE_VENUES = 10

export enum ManagementUserRole {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export enum ManagementUserRoleName {
  ADMIN = 'Admin',
  USER = 'User',
}

export enum ManagementUserEvent {
  CREATED = 'MANAGEMENT_USER_CREATED',
  UPDATED = 'MANAGEMENT_USER_UPDATED',
  INVITED = 'MANAGEMENT_USER_INVITED',
  INVITED_ADMIN = 'MANAGEMENT_USER_INVITED_ADMIN',
  REGISTERED = 'MANAGEMENT_USER_REGISTERED',
}

export enum ManagementUserSignUpType {
  INVITED = 'INVITED',
  REGISTERED = 'REGISTERED',
}

export enum ManagementUserThemePreference {
  SYSTEM = 'system',
  LIGHT = 'light',
  DARK = 'dark',
}

/** @deprecated use SupportedLocale */
export const ManagementUserLanguagePreference = SupportedLocale
/** @deprecated use SupportedLocale */
export type ManagementUserLanguagePreference = SupportedLocale
